import { ChartInterval } from '../types.ts';

export const chartIntervalValueToKey: Record<string, keyof typeof ChartInterval> = Object.entries(
  ChartInterval
).reduce(
  (acc, [key, value]) => {
    acc[value] = key as keyof typeof ChartInterval;
    return acc;
  },
  {} as Record<string, keyof typeof ChartInterval>
);
